import { defineMessages } from 'react-intl';

export default defineMessages({
  danaDelivery: {
    id: 'danaDelivery',
    defaultMessage: 'Dana Delivery',
  },
  orderList: {
    id: 'orderlist',
    defaultMessage: 'Order List',
  },
  partnerList: {
    id: 'partnerList',
    defaultMessage: 'Partner Management',
  },
  clientList: {
    id: 'clientList',
    defaultMessage: 'Client Management',
  },
});
